import { emptyDeal, type Deal } from './flip';
import { newId } from './ids';
import type { Car } from './types';

const line = (label: string, amount: number) => ({ id: newId(), label, amount });

function car(title: string, reg: string, status: Car['status'], deal: Partial<Deal>, extra: Partial<Car> = {}): Car {
  const d: Deal = { ...emptyDeal(), ...deal };
  const now = new Date().toISOString();
  return {
    id: newId(), title, reg, source: 'Example', status, planned: structuredClone(d), deal: d,
    boughtOn: '', soldOn: '', notes: 'Example car: edit or delete it.', checks: {}, createdAt: now, updatedAt: now, ...extra,
  };
}

/** A few made-up cars so the app has something to show. All figures are invented. */
export function demoCars(): Car[] {
  return [
    car('2011 Ford Fiesta 1.2 (example)', 'EX11 AMP', 'listed', {
      purchasePrice: 1450, collection: 15, mot: 55, repairs: [line('Front brake discs and pads', 120), line('Two tyres', 90)],
      salePrice: 2250, saleFeePct: 0, adFee: 20, holdingDays: 18,
    }, { boughtOn: '2026-09-01' }),
    car('2009 Vauxhall Corsa 1.0 (example)', 'EX09 PLE', 'watching', {
      purchasePrice: 700, mot: 55, repairs: [line('Clutch', 220)], salePrice: 1350, adFee: 20, holdingDays: 25,
    }),
    car('2012 Honda Jazz (example)', 'EX12 DEM', 'sold', {
      purchasePrice: 1800, collection: 20, mot: 0, repairs: [line('Service and cambelt check', 150)],
      salePrice: 2600, adFee: 20, holdingDays: 14,
    }, { boughtOn: '2026-08-02', soldOn: '2026-08-16' }),
  ];
}
